import './bootstrap';
import moment from 'moment';
import 'devbridge-autocomplete';
import 'jquery-datetimepicker';
import 'lightbox2';
import 'bootstrap-fileinput';

window.moment = moment;
